import type React from 'react';
import { useLocation } from 'react-router-dom';

import UsersAdminPage from 'containers/admin/users/users-admin-page';

interface UsersTabProps {
  clientId: string | number;
}

interface UsersTabLocationState {
  notificationParams?: Record<string, unknown> | null;
}

const UsersTab = ({ clientId }: UsersTabProps): React.JSX.Element => {
  const location = useLocation();
  const state = location.state as UsersTabLocationState | null;

  return (
    <div className="relative flex flex-1 flex-col">
      <UsersAdminPage
        clientId={clientId}
        notificationParams={state?.notificationParams as never}
        isTab={true}
      />
    </div>
  );
};

export default UsersTab;
